import { Form } from '../../../internal';

export class FormRenderer extends Form {
  
    draw() {
        return <div className="alert bgc-primary-l4 brc-primary-m4 d-flex align-items-center text-dark-tp2"><i className='fas fa-info-circle mr-3 fa-2x text-blue'></i> Standard form renderer not implement.</div> 
    };
}